<template>
    <div>
        <app-erros-box
            :erros="erros"
            v-if="erros.length > 0"
        ></app-erros-box>

        <b-row>
            <b-col class="col-12 col-md-6 col-lg-2">
                <b-form-group>
                    <label>Contrato</label>
                    <b-form-input :disabled="true" v-model="contrato.codContrato"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col class="col-12 col-md-6 col-lg-2">
                <b-form-group>
                    <label>Vigência</label>
                    <b-form-input :disabled="true" v-model="vigencia"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col class="col-12 col-md-6 col-lg-2">
                <b-form-group>
                    <label>Saldo do Contrato</label>
                    <money
                        v-model="saldoContrato"
                        :disabled="true"
                        class="form-control text-right"
                        v-bind="moneyOptions"
                    ></money>
                </b-form-group>
            </b-col>
            <b-col class="col-12 col-md-6 col-lg-2">
                <b-form-group>
                    <label class="required">Data Início da Medição</label>
                    <date-picker
                        v-model="dataInicio"
                        :config="$datePickerOptions"
                        v-mask="'##/##/####'"
                        @input="onDataInicioInput"
                        @dp-change="onDataInicioInput"
                        @input.native="onDataInicioInput"
                        :class="deveExibirErroDataInicio ? 'is-invalid' : ''"
                    ></date-picker>
                    <b-form-invalid-feedback v-if="deveExibirErroDataInicio" class="d-block">
                        <span class="d-block" v-if="!$v.dataInicio.required">
                            A Data Início da Medição é obrigatória
                        </span>
                        <span class="d-block" v-if="!$v.dataInicio.dataInicioNaoPosteriorDataCriacaoBoletim">
                            A Data Início da Medição deve ser igual ou menor a data de criação do boletim de medição
                        </span>
                        <span class="d-block" v-if="!$v.dataInicio.dataDentroVigenciaContrato">
                            A Data Início da Medição deve estar dentro da vigência do contrato
                        </span>
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col class="col-12 col-md-6 col-lg-2">
                <b-form-group>
                    <label class="required">Data Fim da Medição</label>
                    <date-picker
                        v-model="dataFim"
                        :config="$datePickerOptions"
                        v-mask="'##/##/####'"
                        @input="onDataFimInput"
                        @dp-change="onDataFimInput"
                        @input.native="onDataFimInput"
                        :class="deveExibirErroDataFim ? 'is-invalid' : ''"
                    ></date-picker>
                    <b-form-invalid-feedback v-if="deveExibirErroDataFim" class="d-block">
                        <span class="d-block" v-if="!$v.dataFim.required">
                            A Data Fim da Medição é obrigatória
                        </span>
                        <span class="d-block" v-if="!$v.dataFim.dataMaiorOuIgualDataInicio">
                            A Data Fim da Medição deve ser igual ou posterior a data início
                        </span>
                        <span class="d-block" v-if="!$v.dataFim.dataFimNaoPosteriorDataCriacaoBoletim">
                            A Data Fim da Medição deve ser igual ou menor a data de criação do boletim de medição
                        </span>
                        <span class="d-block" v-if="!$v.dataFim.dataDentroVigenciaContrato">
                            A Data Fim da Medição deve estar dentro da vigência do contrato
                        </span>
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col class="col-12 col-md-6 col-lg-2">
                <b-form-group>
                    <label>Competência</label>
                    <date-picker
                        v-model="competencia"
                        :config="$monthPickerOptions"
                        v-mask="'##/####'"
                        :disabled="true"
                    ></date-picker>
                </b-form-group>
            </b-col>
        </b-row>

        <hr>
        <div class="h6">DADOS DO PROCESSO</div>

        <b-row class="mt-4">
            <b-col class="col-md-6">
                <b-form-group>
                    <label class="required">Nome</label>
                    <b-form-input
                        v-model="nome"
                        placeholder="Digite o nome"
                        @input="$v.nome.$touch()"
                        :state="$v.nome.$error ? false : null"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                        <span v-if="!$v.nome.required">
                            O Nome é obrigatório
                        </span>
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col class="mt-n2">
                <b-form-group>
                    <b-form-checkbox v-model="naoRequerEnvio" value="true" unchecked-value="false">
                        Não requer envio
                    </b-form-checkbox>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-form-group>
                    <label>Texto Complementar</label>
                    <b-form-textarea v-model="textoComplementar" rows="3" max-rows="6" :no-resize="true"
                        @keyup="$v.textoComplementar.$touch"
                        :state="$v.textoComplementar.$error ? false : null"></b-form-textarea>
                    <b-form-invalid-feedback>
                        <span v-if="!$v.textoComplementar.quantidadeCaracteresAceita">
                            O Texto Complementar, se informado, deve ter no mínimo 10 e no máximo 500 caracteres
                        </span>
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-col>
        </b-row>

        <hr>
        <div class="h6">DADOS DA REQUISIÇÃO</div>

        <b-row class="mt-4">
            <b-col>
                <b-form-group>
                    <label for="filtro" class="required">Solicitante</label>
                    <model-list-select
                        :list="solicitantes"
                        v-model="solicitante"
                        option-text="nome"
                        option-value="codFuncionario"
                        @input="$v.solicitante.$touch()"
                        :class="$v.solicitante.$error ? 'is-invalid' : ''"
                    ></model-list-select>
                    <b-form-invalid-feedback v-if="$v.solicitante.$error" class="d-block">
                        <span v-if="!$v.solicitante.required || !$v.solicitante.validSolicitante">
                            O Solicitante é obrigatório
                        </span>
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-col>

            <b-col>
                <b-form-group>
                    <label class="required">Contato do Solicitante</label>
                    <b-form-input v-model="contatoSolicitante" @input="$v.contatoSolicitante.$touch()"
                        :state="$v.contatoSolicitante.$error ? false : null"></b-form-input>
                    <b-form-invalid-feedback>
                        <span v-if="!$v.contatoSolicitante.required">
                            O Contato do Solicitante é obrigatório
                        </span>
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-col>

            <b-col>
                <b-form-group>
                    <label class="required">Data da Necessidade</label>
                    <date-picker v-model="dataNecessidade" :config="$datePickerOptions"
                        v-mask="'##/##/####'" @input.native="$v.dataNecessidade.$touch()"
                        :class="$v.dataNecessidade.$error ? 'is-invalid' : ''"></date-picker>
                    <b-form-invalid-feedback v-if="$v.dataNecessidade.$error" class="d-block">
                        <span v-if="!$v.dataNecessidade.required">
                            A Data da Necessidade é obrigatória
                        </span>
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-col>

            <b-col>
                <b-form-group>
                    <label class="required">Data da Entrada</label>
                    <date-picker v-model="dataEntrada" :config="$datePickerOptions" v-mask="'##/##/####'"
                        @input.native="$v.dataEntrada.$touch()" :class="$v.dataEntrada.$error ? 'is-invalid' : ''"></date-picker>
                    <b-form-invalid-feedback v-if="$v.dataEntrada.$error" class="d-block">
                        <span v-if="!$v.dataEntrada.required">
                            A Data da Entrada é obrigatória
                        </span>
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div>
                    <b-button variant="outline-danger" class="mr-2" @click.stop="cancelar()">
                        Cancelar
                    </b-button>

                    <b-button variant="primary" @click.stop="salvar()" :disabled="$v.$invalid">
                        Salvar
                    </b-button>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>

import { required } from 'vuelidate/lib/validators'
import { ModelListSelect } from 'vue-search-select'
import BoletimMedicaoServicos from "../BoletimMedicaoServicos";
import BtnInserirAnexoMedicao from './BtnInserirAnexoMedicao.vue';
import { tiposAnexo, tiposAnexoEnum } from '../tiposAnexo.js'
import { statusBoletimMedicaoEnum, obterDescricaoStatusBoletimMedicao } from '../BoletimMedicao.js'

export default {

    components: {
        ModelListSelect,
        BtnInserirAnexoMedicao
    },

    props: {
        contrato: {
            type: Object,
            default: null
        },
        valorTotalBoletins: {
            type: Number,
            default: 0
        },
    },

    data() {
        return {
            erros: [],
            medicaoId: null,
            competencia: "",
            naoRequerEnvio: false,
            nome: "",
            textoComplementar: '',
            solicitante: {},
            contatoSolicitante: "",
            dataInicio: "",
            dataFim: "",
            dataCriacaoBoletim: "",
            dataNecessidade: "",
            dataEntrada: "",
            solicitantes: [],
            anexos: [],
            status: null,
            camposTabela: [
                {
                    label: 'Arquivo',
                    key: 'nome',
                    sortable: true,
                },
                {
                    label: 'Tipo',
                    key: 'tipoDescricao',
                    sortable: true,
                },
                {
                    label: 'Data',
                    key: 'data',
                    sortable: true,
                },
                {
                    label: 'Tamanho',
                    key: 'tamanho',
                    sortable: true,
                },
                {
                    label: 'Ações',
                    key: 'acoes',
                }
            ],
            moneyOptions: {
                prefix: 'R$ ',
                decimal: ',',
                thousands: '.',
                precision: 2,
                masked: false
            },
        }
    },

    computed: {
        vigencia() {
            return this.$moment(this.contrato.inicioVigencia).format('DD/MM/YYYY') + ' a ' + this.$moment(this.contrato.fimVigencia).format('DD/MM/YYYY')
        },
        saldoContrato() {
            return (this.contrato.valorTotal || 0) - (this.valorTotalBoletins || 0)
        },
        deveExibirErroDataInicio() {
            return this.$v.dataInicio.$invalid && (this.$v.dataInicio.$dirty || !!this.dataInicio)
        },
        deveExibirErroDataFim() {
            return this.$v.dataFim.$invalid && (this.$v.dataFim.$dirty || !!this.dataFim)
        },
    },

    methods: {
        obterDescricaoStatusBoletimMedicao,

        onDataInicioInput() {
            this.$v.dataInicio.$touch()
            if (this.dataFim)
                this.$v.dataFim.$touch()
        },

        onDataFimInput() {
            this.$v.dataFim.$touch()
            if (this.dataInicio)
                this.$v.dataInicio.$touch()
        },

        isAtualizacaoBoletim() {
            return this.$route.name == 'FornecedorContratos_BoletinsMedicoes_Atualizar'
        },

        obterDataPorFormato(data) {
            return this.$moment(data, 'DD/MM/YYYY', true)
        },

        obterDataCriacaoDoBoletim(boletimMedicao) {
            const historico = boletimMedicao?.historico

            if (!Array.isArray(historico) || !historico.length)
                return ''

            const datasHistorico = historico
                .map(item => this.$moment(item?.data))
                .filter(data => data.isValid())

            if (!datasHistorico.length)
                return ''

            const dataCriacao = datasHistorico
                .sort((a, b) => a.valueOf() - b.valueOf())[0]

            return dataCriacao.format('DD/MM/YYYY')
        },

        obterDataLimiteDataFim() {
            const dataBase = this.obterDataPorFormato(this.dataCriacaoBoletim)
            return dataBase.isValid()
                ? dataBase
                : this.$moment()
        },

        obterCompetenciaDaDataFim() {
            const dataFim = this.obterDataPorFormato(this.dataFim)
            return dataFim.isValid()
                ? dataFim.format('MM/YYYY')
                : ''
        },

        atualizarCompetenciaComBaseNaDataFim() {
            this.competencia = this.obterCompetenciaDaDataFim()
        },

        isDataDentroVigenciaContrato(data) {
            if (!data || !this.contrato || !this.contrato.inicioVigencia || !this.contrato.fimVigencia)
                return true

            const dataInformada = this.obterDataPorFormato(data)
            if (!dataInformada.isValid())
                return true

            const inicioVigencia = this.$moment(this.contrato.inicioVigencia).startOf('day')
            const fimVigencia = this.$moment(this.contrato.fimVigencia).endOf('day')

            if (!inicioVigencia.isValid() || !fimVigencia.isValid())
                return true

            return dataInformada.isBetween(inicioVigencia, fimVigencia, 'day', '[]')
        },

        obterBoletimMedicao() {
            this.$store.dispatch('addRequest')

            BoletimMedicaoServicos.obterBoletimMedicao(this.contrato.contratoId, this.$route.params.idBoletimMedicao)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.boletimMedicaoId = response.data.boletimMedicaoId
                            this.competencia = this.$moment(response.data.competencia).format('MM/YYYY')
                            this.naoRequerEnvio = response.data.naoRequerEnvio
                            this.nome = response.data.nome
                            this.textoComplementar = response.data.textoComplementar ?? ''
                            this.contatoSolicitante = response.data.contatoSolicitante
                            this.dataInicio = response.data.dataInicio
                                ? this.$moment(response.data.dataInicio).format('DD/MM/YYYY')
                                : ""
                            this.dataFim = response.data.dataFim
                                ? this.$moment(response.data.dataFim).format('DD/MM/YYYY')
                                : ""
                            this.dataCriacaoBoletim = this.obterDataCriacaoDoBoletim(response.data)
                            this.dataNecessidade = this.$moment(response.data.dataNecessidade).format('DD/MM/YYYY')
                            this.dataEntrada = this.$moment(response.data.dataEntrada).format('DD/MM/YYYY')
                            this.anexos = this.recriarAnexos(response.data.anexos)
                            this.solicitante = this.solicitantes.find(item => item.codFuncionario == response.data.codigoSolicitante)
                            this.status = response.data.status

                            this.$emit('atualizarStatusBoletimMedicao', obterDescricaoStatusBoletimMedicao(this.status))
                        } else {
                            this.erros = response.errors
                        }

                        this.$store.dispatch('removeRequest')
                    }
                })
                .catch(error => {
                    this.$toast.error(
                        'Não foi possível obter os dados do Boletim de medição',
                        'Erro',
                        this.$toastConfig.error
                    )
                    this.$store.dispatch('removeRequest')
                })

        },

        recriarAnexos(anexos) {
            let anexosRecriados = []

            anexos.forEach(function (anexo) {
                const possuiConteudoArquivo = anexo.arquivo && anexo.arquivo.length
                const arquivoAnexo = possuiConteudoArquivo
                    ? new File([new Blob([anexo.arquivo])], anexo.nomeDocumento)
                    : null
                let tipoAnexo = tiposAnexo.find(item => item.id === anexo.tipoAnexoBoletimMedicao)

                anexosRecriados.push({
                    boletimMedicaoId: anexo.boletimMedicaoId,
                    documentoBoletimMedicaoId: anexo.documentoBoletimMedicaoId,
                    nome: anexo.nomeDocumento,
                    arquivo: arquivoAnexo,
                    tipo: tipoAnexo.id,
                    tipoDescricao: tipoAnexo.descricao,
                    data: anexo.data,
                    tamanho: anexo.tamanho
                })
            })

            return anexosRecriados
        },

        obterListaSolicitantes() {
            this.$store.dispatch('addRequest')

            BoletimMedicaoServicos.obterOpcoesFiltro()
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.solicitantes = response.data.solicitantes
                        } else {
                            this.erros = response.errors
                        }
                    }

                    this.$store.dispatch('removeRequest')
                })
                .catch(error => {
                    this.$toast.error(
                        'Não foi possível obter a lista de Solicitantes',
                        'Erro',
                        this.$toastConfig.error
                    )
                })

        },

        adicionarAnexo(anexo) {
            this.anexos.push(anexo)
        },

        removerAnexo(anexo) {
            this.anexos = this.anexos.filter(a => a.nome !== anexo.nome)
        },

        salvar() {
            if (this.isAtualizacaoBoletim()) {
                this.atualizarBoletim()
            } else {
                this.inserirBoletim()
            }
        },

        cancelar() {
            this.$swal({
                title: 'Boletim de Medição de Contrato',
                html: "Deseja realmente cancelar as alterações desse Boletim de Medição ?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {

                    this.$router.push({ name: 'FornecedorContratos_BoletinsMedicoes' })
                }
            })
        },

        inserirBoletim() {
            this.$store.dispatch('addRequest')

            let boletimMedicaoDto = {
                contratoId: this.contrato.contratoId,
                competencia: this.obterCompetenciaDaDataFim(),
                naoRequerEnvio: this.naoRequerEnvio,
                nome: this.nome,
                textoComplementar: this.textoComplementar,
                codigoSolicitante: this.solicitante.codFuncionario,
                contatoSolicitante: this.contatoSolicitante,
                dataInicio: this.dataInicio ? this.$moment(this.dataInicio, 'DD/MM/YYYY').toISOString() : null,
                dataFim: this.dataFim ? this.$moment(this.dataFim, 'DD/MM/YYYY').toISOString() : null,
                dataNecessidade: this.$moment(this.dataNecessidade, 'DD/MM/YYYY').toISOString(),
                dataEntrada: this.$moment(this.dataEntrada, 'DD/MM/YYYY').toISOString(),
                anexos: this.anexos
            }

            BoletimMedicaoServicos.inserirBoletimMedicao(
                boletimMedicaoDto
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Boletim de medição cadastrado com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )

                        this.$emit('recarregarListaBoletinsMedicao')
                    } else {
                        this.erros = response.errors

                        this.$toast.error(
                            'Erro ao inserir o Boletim de medição',
                            'Erro',
                            this.$toastConfig.error
                        )
                    }

                    this.$store.dispatch('removeRequest')
                }
            }).catch(error => {
                this.$store.dispatch('removeRequest')
                this.$toast.error(
                    'Erro ao inserir o Boletim de medição',
                    'Erro',
                    this.$toastConfig.error
                )
            })
        },

        atualizarBoletim() {
            this.$store.dispatch('addRequest')

            let boletimMedicaoDto = {
                boletimMedicaoId: this.boletimMedicaoId,
                contratoId: this.contrato.contratoId,
                competencia: this.obterCompetenciaDaDataFim(),
                naoRequerEnvio: this.naoRequerEnvio,
                nome: this.nome,
                textoComplementar: this.textoComplementar,
                codigoSolicitante: this.solicitante.codFuncionario,
                contatoSolicitante: this.contatoSolicitante,
                dataInicio: this.dataInicio ? this.$moment(this.dataInicio, 'DD/MM/YYYY').toISOString() : null,
                dataFim: this.dataFim ? this.$moment(this.dataFim, 'DD/MM/YYYY').toISOString() : null,
                dataNecessidade: this.$moment(this.dataNecessidade, 'DD/MM/YYYY').toISOString(),
                dataEntrada: this.$moment(this.dataEntrada, 'DD/MM/YYYY').toISOString(),
                anexos: this.anexos
            }

            BoletimMedicaoServicos.atualizarBoletimMedicao(
                boletimMedicaoDto
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Boletim de medição atualizada com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )

                        this.$emit('recarregarDadosBoletim')
                    } else {
                        this.erros = response.errors

                        this.$toast.error(
                            'Erro ao atualizar o Boletim de medição',
                            'Erro',
                            this.$toastConfig.error
                        )
                    }
                }

                this.$store.dispatch('removeRequest')
            })
            .catch(error => {
                this.$store.dispatch('removeRequest')
                this.$toast.error(
                    'Erro ao atualizar o Boletim de medição',
                    'Erro',
                    this.$toastConfig.error
                )
            })

        },

        podeRemoverAnexo(anexo) {
            return ((anexo.tipo == tiposAnexoEnum.BoletimMedicao) &&  (this.status == statusBoletimMedicaoEnum.Criado || this.status == statusBoletimMedicaoEnum.DevolvidoParaCorrecao)) ||
                    ((anexo.tipo == tiposAnexoEnum.NotaFiscal ) &&  (this.status == statusBoletimMedicaoEnum.AprovadoParaEnvioNotaFiscal || this.status == statusBoletimMedicaoEnum.NotaFiscalDevolvidaParaCorrecao)) ||
                    (anexo.tipo == tiposAnexoEnum.CertidoesDocumentosComprobatorios && false)
        },
    },

    watch: {
        dataFim() {
            this.atualizarCompetenciaComBaseNaDataFim()
        }
    },

    validations: {
        nome: {
            required
        },
        textoComplementar: {
            quantidadeCaracteresAceita(value) {
                return (!value || (value.length >= 10 && value.length <= 500))
            }
        },
        solicitante: {
            required,
            validSolicitante(value) {
                return value && value.codFuncionario
            }
        },
        contatoSolicitante: {
            required
        },
        dataNecessidade: {
            required
        },
        dataEntrada: {
            required
        },
        dataInicio: {
            required,
            dataInicioNaoPosteriorDataCriacaoBoletim(value) {
                const dataInicio = this.obterDataPorFormato(value)
                if (!dataInicio.isValid())
                    return true

                return dataInicio.isSameOrBefore(this.obterDataLimiteDataFim(), 'day')
            },
            dataDentroVigenciaContrato(value) {
                return this.isDataDentroVigenciaContrato(value)
            }
        },
        dataFim: {
            required,
            dataMaiorOuIgualDataInicio(value) {
                const dataFim = this.obterDataPorFormato(value)
                const dataInicio = this.obterDataPorFormato(this.dataInicio)

                if (!dataFim.isValid() || !dataInicio.isValid())
                    return true

                return dataFim.isSameOrAfter(dataInicio, 'day')
            },
            dataFimNaoPosteriorDataCriacaoBoletim(value) {
                const dataFim = this.obterDataPorFormato(value)
                if (!dataFim.isValid())
                    return true

                return dataFim.isSameOrBefore(this.obterDataLimiteDataFim(), 'day')
            },
            dataDentroVigenciaContrato(value) {
                return this.isDataDentroVigenciaContrato(value)
            }
        }
    },

    created() {
        this.obterListaSolicitantes()
        this.atualizarCompetenciaComBaseNaDataFim()
        this.dataCriacaoBoletim = this.$moment().format('DD/MM/YYYY')

        if (this.isAtualizacaoBoletim())
            this.obterBoletimMedicao()
    },
}
</script>
